import React from "react";

export function Header({ children }) {
  return (
    <div className="rounded-md border-b border-gray-100 bg-white px-0">
      {children && React.Children.map(children, (child) => React.cloneElement(child))}
    </div>
  );
}
